import React from 'react'
import './Calendar.css'
import { Image, Container } from 'react-bootstrap';
import MenuNavbar from '../function-components/MenuNavbar';
import NavTabs from '../function-components/NavTabs';
import NavTabsNew from './NavTabsNew';
import { useMsal } from "@azure/msal-react";

function Calendar() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  let ipsLoggedInEnterpriseId = '';
  if (activeAccount) {
    ipsLoggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  }

  const allowedUsersForCalendar = [
    'h.srinivasan',
    'jeevadharani.ramanan',
    'ankur.e.mishra',
    'arpita.m.singh',
    'aayushi.bharti',
    'aluru.akash',
    'uma.rani.battu',
    'reshmi.haridas.m',
    'j.b.bhardwaj',
    'shramika.s.ambolkar',
    'manasa.velagaleti',
    'varsha.a.tyagi',
    'preethi.kolkur',
    'keerthi.bhupelli',
    'devika.gajanan.pote',
    's.saraswathi',
    'd.d.choudhary',
    'lakshay.c.gupta',
    'akash.e.tyagi',
    'lavanya.umesh',
    'sunil.l.singh',
    'abhishek.r.pandey'
  ];
  return (
    <>
      {/* Banner Image */}
      <div className="banner-container calendar">
        <img src={process.env.PUBLIC_URL + "/images/Banner1.png"} alt="home-banner" className='banner' />
        {/* <h1>Security Learning Hub Calendar</h1> */}
        <MenuNavbar />
      </div>

      {/* Heading */}
      <Container fluid>
        <div className="first-head container__fluid">
          {/* <p className="level1-heading">About SAP</p>
            <p className="first-head">
              {" "}
              In today’s fast driven technology ecosystem, SAP is the market
              leader in providing ERP (Enterprise Resource Planning) solutions
              and services. SAP acts as an enterprise wide information system
              designed to support and integrate almost all the functional areas
              of business processes such as Human Resources, Sales and
              Distribution, Finance, Logistics, Production Planning,
              Manufacturing, etc. SAP has evolved to what it is today; providing
              solutions on the latest technical advancements like Cloud, Big
              data, IoT, Artificial Intelligence, Machine Learning, Analytics
              and so on.
            </p> */}
        </div>
      </Container>
      {allowedUsersForCalendar.includes(ipsLoggedInEnterpriseId) ?
        <NavTabsNew />
        : <NavTabs />}


    </>
  );
}

export default Calendar;
